/**
 * Vibeship DevTools
 * 
 * Comprehensive markdown-based project management system for Next.js applications
 */

// Export all type definitions
export * from './types';

// Export provider components
export { VibeshipProvider } from './providers/VibeshipProvider';
export { VibeshipServerProvider } from './providers/VibeshipServerProvider';
export { VibeshipProvider as VibecodeProvider } from './providers/VibeshipProvider'; // Backwards compatibility
export { VibeshipProviderWithDeps } from './providers/VibeshipProviderWithDeps';
export { VibeshipProviderWithDeps as VibecodeProviderWithDeps } from './providers/VibeshipProviderWithDeps'; // Backwards compatibility
export { ErrorBoundary, withErrorBoundary } from './providers/ErrorBoundary';

// Re-export types
export type { VibeshipProviderDependencies } from './providers/VibeshipProviderWithDeps';
export type { VibeshipProviderDependencies as VibecodeProviderDependencies } from './providers/VibeshipProviderWithDeps'; // Backwards compatibility

// Export browser-safe configuration utilities only
export { defaultConfig } from './config/defaults';
export { mergeConfigurations } from './config/merger';

// Browser-safe defineConfig function (server version is in ./config/loader)
export function defineConfig<T extends Record<string, any> = any>(config: T): T {
  return config;
}

// AI Features (optional - requires AI SDK peer dependencies)
export { AISettingsPanel } from './components/AISettingsPanel';
export { AISettingsProvider, useAISettings } from './contexts/AISettingsContext';

// Export AI services
export { AIService as AIServiceImplementation } from './services/ai/ai-service';
export { ProviderRegistry, providerRegistry } from './services/ai/provider-registry';
export { OpenAIProvider } from './services/ai/providers/openai-provider';
export { AnthropicProvider } from './services/ai/providers/anthropic-provider';
export { XAIProvider } from './services/ai/providers/xai-provider';

// AI types are already exported through ./types

// Security utilities for API key management
export * from './services/security/api-key-manager';
export * from './services/security/encryption-service';

// Version
export const VERSION = '1.1.0';